import BalanceSummaryDetailView from '../../components/Balances/BalanceSummaryDetailView'

export const BalancesContainer: React.FC = () => {
  return <BalanceSummaryDetailView />
}
